import React, { useEffect, useState } from 'react';

function OwnedCoachAttachment({ attachment, backendService, index }) {
  const [objectUrl, setObjectUrl] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);
  const name = attachment.name || `Photo ${index + 1}`;

  useEffect(() => {
    let active = true;
    let loadedUrl = null;
    setObjectUrl(null);
    setLoadFailed(false);

    if (!attachment?.id || !backendService?.fetchCoachAttachment) {
      setLoadFailed(true);
      return undefined;
    }

    backendService.fetchCoachAttachment(attachment.id)
      .then(url => {
        loadedUrl = url;
        if (active) setObjectUrl(url);
        else if (url && URL.revokeObjectURL) URL.revokeObjectURL(url);
      })
      .catch(() => {
        if (active) setLoadFailed(true);
      });

    return () => {
      active = false;
      if (loadedUrl && URL.revokeObjectURL) URL.revokeObjectURL(loadedUrl);
    };
  }, [attachment?.id, backendService]);

  if (loadFailed) {
    return <span className="exercise-coach-message-attachment-error">{name} unavailable</span>;
  }
  if (!objectUrl) {
    return <span className="exercise-coach-message-attachment-loading">Loading {name}…</span>;
  }

  return (
    <a
      className="exercise-coach-message-attachment"
      href={objectUrl}
      target="_blank"
      rel="noreferrer"
    >
      <img src={objectUrl} alt={name} />
    </a>
  );
}

function ExerciseCoachMessageAttachments({ attachments = [], backendService }) {
  const visible = attachments.filter(attachment => (
    attachment?.id && (attachment?.kind === 'image' || (attachment?.mime_type || '').startsWith('image/'))
  ));
  if (visible.length === 0) return null;

  return (
    <div className="exercise-coach-message-attachments">
      {visible.map((attachment, index) => (
        <OwnedCoachAttachment
          attachment={attachment}
          backendService={backendService}
          index={index}
          key={`${attachment.id}-${index}`}
        />
      ))}
    </div>
  );
}

export default ExerciseCoachMessageAttachments;
